var delta = delta || {};
delta.pageParams = function () {
    var 
    
    //this is what we want to pass to the server.  It includes the param name and encrypted value
    // ex: 
    _pageParms = null,

    //
    //init
    //
    init = function() {
        //get the page params from the globals
        if (typeof gPageParams !== 'undefined') _pageParms = gPageParams;
    },

    //
    // get the page params
    //
    getPageParams = function() {
        return _pageParms;
    },

    dummy = function(){};

    //call init
    $(document).ready(init);

    return {
        getPageParams: getPageParams
    };
}();